import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return <div className="container mt-5 text-center"><div className="spinner-border" /></div>;
  if (!token)  return <Navigate to="/login" replace />;
  return children;
}
